import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class UserService {
  observeResponse: any = { observe: 'response' };
  apiPrefix = '/Login/';

  constructor(private readonly http: HttpClient) {}

  IsScheduler(): Observable<any> {
    return this.http.get(environment.apiEndPoint + this.apiPrefix + 'IsScheduler', { ...this.observeResponse });
  }

  IsGeneralUser(): Observable<any> {
    return this.http.get(environment.apiEndPoint + this.apiPrefix + 'IsGeneralUser', { ...this.observeResponse });
  }
  GetCurrentUser(): Observable<any> {
    return this.http.get(environment.apiEndPoint + this.apiPrefix + 'GetCurrentUser', { ...this.observeResponse });
  }

  GetEmployeeProfile(): Observable<any> {
    return this.http.get(environment.apiEndPoint + this.apiPrefix + 'GetEmployeeProfile', { ...this.observeResponse });
  }
}
